import React, { FC } from "react";
import HomeContainer from "../../container/HomeContainer";
const HomePage: FC = () => {
  return (
    <div>
      <HomeContainer />
    </div>
  );
};

export default HomePage;
